import React from 'react';
import { OwnerManualResponse } from '../../services/owner-manual-service/owner-manual-service';
import { OwnerManualProps } from '../../pages/owner-manual/hook/use-owner-manual-content';

export const pastPrintingsFunction = (
    sortedOMDataCategory: any[],
    ownerManualData: OwnerManualResponse | null,
    isCanadaTransit: boolean,
    downloadAnalytic: (guideName: string) => void,
    ownerManualContent: OwnerManualProps | null
): React.JSX.Element[] => {
    const pastPrintings: React.JSX.Element[] = [];

    sortedOMDataCategory &&
        ownerManualData &&
        !ownerManualData.metadata.error &&
        !isCanadaTransit &&
        sortedOMDataCategory.forEach((article, key) => {
            let articleCondition: any;
            if (sortedOMDataCategory[0].secondaryCategory === 'PDF') {
                articleCondition = 0;
            } else {
                articleCondition = 1;
            }
            if (
                article.secondaryCategory !== 'HTML' &&
                key !== articleCondition
            )
                pastPrintings.push(
                    <li key={article.title}>
                        <a
                            href={article.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() => {
                                downloadAnalytic(article.title);
                            }}
                        >
                            <div className="om-article-title">
                                <span className="manual-guide-span">
                                    {article.title}
                                </span>
                                {ownerManualContent && (
                                    <span className="view-span">
                                        {ownerManualContent.detailsViewDocument}
                                    </span>
                                )}
                            </div>
                        </a>
                    </li>
                );
        });

    return pastPrintings;
};

export const getArticleDetails = (
    sortedOMDataCategory: any[],
    article: any,
    categoryName: string
) => {
    if (!categoryName) categoryName = article.category;
    let articleCondition: any;
    if (sortedOMDataCategory[0].secondaryCategory === 'PDF') {
        articleCondition = 0;
    } else {
        articleCondition = 1;
    }
    return { categoryName, articleCondition };
};
